import { useEffect, useRef } from "react";
// src/hooks/usePrevious.ts
function usePrevious(value) {
	const ref = useRef(null);
	useEffect(() => {
		ref.current = value;
	}, [value]);
	return ref.current;
}
export { usePrevious };

//# sourceMappingURL=usePrevious.js.map